<template>
  <div class="cx_sidebar_item" v-if="isShow()" :class="{ active: isActive() }"  :draggable="isActive() && parent !=null"  @dragstart="$emit('dragstart',$event)" @dragover="$emit('dragover',$event)" @drop="$emit('drop',$event)" @dragleave="$emit('dragleave')">
    <div class="cx_sidebar_item_left" @click="collapse" @mousedown="reset" >
      <!-- リンク既定のdraggableを無効化 -->
      <b-link class="nav-link"  :to="to" :disabled="$api.perms.hasMenuPermission(perm) == false" :draggable="false">
        <div class="cx_sidebar_item_content">
          <span class="cx_sidebar_title" >
            {{ indentChars
            }}<span>
              <i class="material-icons small valign" :style="{ color: iconColor }" v-if="icon">{{ icon }}</i>
              <SvgIcon :name="svg" v-if="svg" :width="28" :height="28"/>
            </span><span  class="cx_sidebar_title_caption">{{$translate(title)}}</span>
            <i  v-if="tooltip" class="material-icons small valign help" ref="tooltip_target">help_outline</i>
            <slot></slot>
            <span class="cx_count" v-if="count || count == 0"> ({{count}})</span>          
          </span>
        </div>
      </b-link>
    </div>
    <span class="cx_sidebar_arrow"><slot name="icon"></slot><i class="material-symbols-outlined small valign" @click="parent.onDelete(to)" v-if="isActive() && parent != null && isFavoriteEditable">delete</i>
    <i class="material-symbols-outlined small valign" v-if="isActive() && parent != null && isFavoriteEditable" >drag_indicator</i></span>
    <!-- <div v-if="isActive()" class="cx_sidebar_item_right">
      <a id="button" @click="onButtonClick"><slot name="button"></slot></a>
    </div> -->
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class SideBarItem extends Vue {
  @Prop() public to!: string;
  @Prop({ default: null }) public perm: string;
  @Prop({ default: null }) public icon: string;
  @Prop({ default: null }) public svg: string;  
  @Prop({ default: 0 }) public indent: number;
  @Prop({ default: '#495057' }) public iconColor: string;
  @Prop({ default: null }) public parent: Components.SideBarGroup;
  @Prop({ default: null }) public title: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({ default: null }) public count: number;
   @Prop({ default: false }) public isFavoriteEditable:boolean; 
  public mounted() {
    if (this.parent != null) this.parent.apend(this);
    if(this.tooltip) this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);    
  }

  public get indentChars(): string {
    let result = '';
    for (let i = 0; i < this.indent; i++) {
      result += '\u00a0';
    }
    return result;
  }
  public isActive() {
    if (this.to){
      //現在のフルパスにstaticが含まれる場合は、フルパスで検索、それ以外は、パスで検索。
      return this.$route.query.static ? this.to == this.$route.fullPath : this.to == this.$route.path;
    } else {
      return false;
    }
    //return this.to != null ? this.to == this.$route.fullPath : false;
  }

  public reset(e: any) {
    //ドラッグイベントと区別できないため、リロード処理を無効化
    
    // if (this.to == this.$route.fullPath) {
    //   //同一URLの場合リロードされないので先にフラグ付きでリロードしたうえで、後続する遷移イベントで上書きする形でリロードする
    //   const query = { ...this.$route.query, refresh: 1 };
    //   const newRoute = { ...this.$route, query };
    //   this.$router.replace(newRoute as any);
    // }
  }
  public collapse() {
    this.$emit('selected', this);
  }

  public onButtonClick() {
    this.$emit('buttonClicked', this);
  }
  // 案件管理機能が無い場合のサイドボタン非表示のリスト
  public static hiddenProjectItem:Array<string> = [
    "/sales/ProjectItem",
  ];
  // 在庫管理機能が無い場合のサイドボタン非表示のリスト
  public static hiddenNoStock: Array<string> = [
    "/master/SKU",
    "/master/Conversion",
    "/master/Assembly",
    "/master/Component",
    "/master/ShelfNo",
    "/sales/SalesCharge",
    "/sales/SalesPicking",
    "/purchase/PurchaseCharge",
    "/journal/StockBalance",
    "/journal/StockTaking",
    "/journal/StockTakingItem",
    "/journal/StockTransfer",
    "/journal/StockTransferItem",
    "/journal/StockRelocation",
    "/journal/StockRelocationItem",
    "/journal/StockReplenishmentCommodity",
  ];
  // 運用管理機能が無い場合のサイドボタン非表示のリスト
  public static hiddenNoOperation: Array<string> = [
    "/system/Group",
    "/system/GroupMember",
    "/system/Permission",
    "/system/Workflow",
    "/system/WorkflowAction",
    "/system/WorkflowPermission",
    // "/system/FileLayout",
    "/system/Topics",
    "/system/ECSetting",   
    "/system/ECCommodity",   
    "/system/BatchSchedule",
    // "/system/PartneredTenant",
    // "/system/PartneredUser",
  ];

  // バージョンによる再度ボタン非表示のリスト
  public static hiddenV241220: Array<string> = [
    // "/system/ECSetting",   // EC連携設定を解放
  ];

  // 受発注管理機能が無い場合のサイドボタン非表示のリスト
  public static hiddenNoSalesPurchaseOrder: Array<string> = [
    "/sales/SalesOrder",
    "/sales/SalesOrderItem",
    "/sales/ProjectItem",
    "/purchase/PurchaseOrder",
    "/purchase/PurchaseOrderItem",
  ];
  
  public isShow() : boolean{
    if (Common.Api.siteMode == Common.siteModes.admin) return true;
    if (this.to){
      // 案件機能が無い場合
      if(this.$api.useProjectItemFunction == false)
      {
        if(SideBarItem.hiddenProjectItem.includes(this.to)) return false;
      }
      // 在庫機能が無い場合
      if(this.$api.useStockFunction == false)
      {
        if(SideBarItem.hiddenNoStock.includes(this.to)) return false;
      }
      // 運用管理機能が無い場合
      if(this.$api.useOperationFunction == false)
      {
        SideBarItem.addHiddenNoOperation("/master/Category")
        if(SideBarItem.hiddenNoOperation.includes(this.to)) return false;
      }
      if(this.$api.useSalesPurchaseOrderFunction == false)
      {
        if(SideBarItem.hiddenNoSalesPurchaseOrder.includes(this.to)) return false;
      }
      // バージョンによる表示制御
      if(this.$api.afterTenantVersion(Common.TenantVersions.Version_241220)==true){
        if(SideBarItem.hiddenV241220.includes(this.to)) return false;
      }
    }
    return true;
  }
  
  private static addHiddenNoOperation(item: string){
    this.hiddenNoOperation.push(item)
  }
}

</script>

<style lang="scss">
.cx_sidebar_item {
  text-align: left;
  padding-left: 5px;
  display: flex;
  border-right: medium solid transparent;  

  &:hover{
    background-color:#afbbce3a;    
  }
  .cx_count{
    font-size: 12px;
  }
  .cx_sidebar_arrow {
    // padding: 12px 16px;
    // width: 30px;
    // padding-right: 16px;
    padding-top: 8px;    
    display: flex;
    align-items: center;    
    i {
      height: 21px;
      &:hover{
        // color: #007bff;     
        color:#fff;   
        cursor: pointer;        
      }
    }
  }

  i.small {
    margin-left:2px;
    margin-bottom:3px;
    margin-right:0px;
    font-size: 15px;
    color:#9e9d9d;      

    &.help:hover{
      color:#007bff;                
      cursor:pointer;
    }      

  }  
}

.cx_sidebar_item a {
  // color: #495057;
  color:#2C304F;
}
.cx_sidebar_item a:hover {
  // color: #007bff;
}

/* アイコン(ホバー時) */
.cx_sidebar_item a:hover i {
  // color: #007bff !important;
}
/* アイコン(アクティブ) */
.cx_sidebar_item.active a i {
  // color: #007bff !important;
}
.cx_sidebar_item.active a {
  
  // color: #007bff;
}

.cx_sidebar_item.active {
  // border-right: medium solid #007bff;
  background-color:#23395ce5;    
  a {
    color:#ffffff;
  }
}


.cx_sidebar_title {
  white-space: nowrap;
  i {
    margin-right: 8px;
  }
  .cx_sidebar_title_caption{
    margin-left:10px;
  }
}
/* アイコン右寄せ */
.cx_sidebar_item_content {
  display: flex;
}

.cx_sidebar_item_content .cx_sidebar_title {
  flex: 1;
}
.cx_sidebar_item_left {
  flex: 1;
  a {
    padding-right: 5px;
  }
}

.cx_sidebar_item_right {
  /* margin: 0px 10px; */
  padding: 0.5rem 1rem;
  /* display: none; */
}

a#button {
  color: #bdc2c796;
}
a#button:hover {
  color: rgba(255, 81, 0, 0.932);
  cursor: pointer;
}
</style>